var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"records-button",domProps:{"innerHTML":_vm._s(_vm.$getString('BTN_ACCESS_RECORDS'))},on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }